import * as Types from '../../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type EpocusStudiesSinceQueryVariables = Types.Exact<{
  since: Types.Scalars['DateTime'];
  programId?: Types.InputMaybe<Types.Scalars['ID']>;
}>;


export type EpocusStudiesSinceQuery = { readonly __typename?: 'Query', readonly epocusStudiesSince: ReadonlyArray<{ readonly __typename?: 'EpocusStudyRouting', readonly status: Types.EpocusStudyRoutingStatus, readonly receivedAt?: string | null, readonly ingressGateId?: string | null, readonly ingressRouteKey?: string | null, readonly programId?: string | null, readonly programName?: string | null }> };


export const EpocusStudiesSinceDocument = gql`
    query EpocusStudiesSince($since: DateTime!, $programId: ID) {
  epocusStudiesSince(since: $since, programId: $programId) {
    status
    receivedAt
    ingressGateId
    ingressRouteKey
    programId
    programName
  }
}
    `;

/**
 * __useEpocusStudiesSinceQuery__
 *
 * To run a query within a React component, call `useEpocusStudiesSinceQuery` and pass it any options that fit your needs.
 * When your component renders, `useEpocusStudiesSinceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEpocusStudiesSinceQuery({
 *   variables: {
 *      since: // value for 'since'
 *      programId: // value for 'programId'
 *   },
 * });
 */
export function useEpocusStudiesSinceQuery(baseOptions: Apollo.QueryHookOptions<EpocusStudiesSinceQuery, EpocusStudiesSinceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EpocusStudiesSinceQuery, EpocusStudiesSinceQueryVariables>(EpocusStudiesSinceDocument, options);
      }
export function useEpocusStudiesSinceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EpocusStudiesSinceQuery, EpocusStudiesSinceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EpocusStudiesSinceQuery, EpocusStudiesSinceQueryVariables>(EpocusStudiesSinceDocument, options);
        }
export type EpocusStudiesSinceQueryHookResult = ReturnType<typeof useEpocusStudiesSinceQuery>;
export type EpocusStudiesSinceLazyQueryHookResult = ReturnType<typeof useEpocusStudiesSinceLazyQuery>;
export type EpocusStudiesSinceQueryResult = Apollo.QueryResult<EpocusStudiesSinceQuery, EpocusStudiesSinceQueryVariables>;